import React, { Component } from 'react';

import { Link } from 'react-router-dom';
import QRCodeComponent from '../../components/QRCode';
import { getOpenId } from '../../service/chat-service';
import config from '../../config/app-config';
import tools from '../../utils/tools';

import styles from './styles.module.less';
import './css/share-code.css';
import logo from '../../public/images/WechatIMG954.png';

import bg01 from './img/bg-01.png';
import bg02 from './img/bg-02.png';
import bg03 from './img/bg-03.png';
import bg04 from './img/bg-04.png';
import bg05 from './img/bg-05.jpg';
import bg06 from './img/bg-06.png';

/**
 * 二维码分析页面
 */
export default class ShareCode extends Component {
  constructor(props) {
    super(props);
    const productId = tools.getQueryString('productId');
    const shareUserId = tools.getQueryString('shareUserId');
    const isWxAuth = tools.isWeixinCient();

    // 二维码链接
    const QRCodeUrl = `${config.qrCodeLink}/productDetail?shareUserId=${shareUserId}&productId=${productId}`;

    this.state = {
      isWxAuth,
      // productId,
      // shareUserId,
      QRCodeUrl,
    };
  }

  componentDidMount() {
    document.title = '天九儒商大学';
    // this.init();
  }

  init = async () => {
    const { isWxAuth } = this.state;
    const { appId } = config;

    // 判断是不是微信环境
    if (!isWxAuth) return false;

    const code = tools.getQueryString('code');
    // 判断是否授权过
    if (!code) {
      localStorage.clear();
      window.location.href = tools.toWxth(appId);
      return false;
    }

    const openId = localStorage.getItem('openId');
    // 判断是否已经授权获取了openId
    if (!openId) {
      const data = `?code=${code}`;
      try {
        const result = await getOpenId(data);
        if (result.code === 10000) localStorage.setItem('openId', result.data);
      } catch (error) {
        // console.log(error);
      }
    }
    return true;
  };

  renderContent = () => {
    const { QRCodeUrl } = this.state;
    return (
      <div className="area menuBackground">
        <div className="bg bg-01">
          <img src={bg01} alt="" />
          <div className="media">
            <video
              autoPlay
              controls="controls"
              poster={bg05}
              src="http://resource.rsdx.com/study-cloud/rsdx_website/video/%E5%AE%A3%E4%BC%A0%E7%89%87%2B%E9%87%91%E5%8F%A5.mp4"
            >
              <track kind="captions" />
            </video>
          </div>
        </div>
        <div className="bg bg-02"><img src={bg02} alt="" /></div>
        <div className="bg bg-03"><img src={bg03} alt="" /></div>
        <div className="bg bg-04">
          <img src={bg04} alt="" />
          <div className="wei">
            <QRCodeComponent
              className={styles.qrCodeImage}
              logo={logo}
              logWidth={30}
              QRCodeUrl={QRCodeUrl}
            />
          </div>
          <Link className="link link-01" to="/productDetailCode/menu1" />
          <Link className="link link-02" to="/productDetailCode/menu2" />
          <Link className="link link-03" to="/productDetailCode/menu3" />
          <Link className="link link-04" to="/productDetailCode/menu4" />
        </div>
        <div className="bg bg-05">
          <img src={bg06} alt="" />
          {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
          <a
            className="link link-01"
            href={'https://v.eqxiu.cn/s/0QsVlN1P?eqrcode=1&share_level=2'
            + '&from_user=201907189bc2e70a&from_id=edb6f336-6&share_time=1566453580366'
            + '&from=singlemessage&isappinstalled=0'}
            label="something"
          />
        </div>
      </div>
    );
  };

  render() {
    return (
      <div>
        {this.renderContent()}
      </div>
    );
  }
}
